import { secondarySearch } from "../../../../../components/indexDB/indexDBStora";
import {
    getBatchQty,
    setBatchQty
} from "./inventorySession";

export async function validationStock(productId, qty, meta) {

    const quantity = Number(qty);

    const result = {
        success: false,
        message: "",
        data: {
            productId: null,
            quantity: 0,
            measure: "",
            affectedBatches: []
        }
    };

    try {

        if (!productId || quantity <= 0) {
            return {
                ...result,
                message: "Invalid data"
            };
        }

        const method = meta?.method?.trim().toLowerCase();

        if (!["fifo", "lifo"].includes(method)) {
            return {
                ...result,
                message: "Invalid inventory method"
            };
        }

        const batches = await secondarySearch(
            "batches",
            "productId",
            productId
        ) || [];

        const validBatches = batches.filter(
            batch => getBatchQty(batch) > 0
        );

        if (method === "fifo") {
            validBatches.sort(
                (a, b) => Number(a.index) - Number(b.index)
            );
        }
        else {
            validBatches.sort(
                (a, b) => Number(b.index) - Number(a.index)
            );
        }

        const totalStock = validBatches.reduce(
            (sum, batch) => sum + getBatchQty(batch),
            0
        );

        let remainingQty =
            meta.measure === "weight"
                ? quantity * 1000
                : quantity;

        if (totalStock < remainingQty) {
            return {
                ...result,
                message: `Insufficient stock for product "${productId}". Available stock: ${totalStock}.`
            };
        }

        const affectedBatches = [];

        for (const batch of validBatches) {

            if (remainingQty <= 0) break;

            const availableQty = getBatchQty(batch);

            const deductedQty = Math.min(
                availableQty,
                remainingQty
            );

            const newQty = availableQty - deductedQty;

            setBatchQty(batch.id, newQty);

            remainingQty -= deductedQty;

            affectedBatches.push({
                ...batch,
                summary: {
                    batchId: batch.id,
                    oldQty: availableQty,
                    deductedQty,
                    remainingQty: newQty
                }
            });

        }

        return {
            success: true,
            message: "Stock available",
            data: {
                productId,
                quantity,
                measure: meta.measure,
                affectedBatches
            }
        };

    }
    catch (err) {

        return {
            ...result,
            message: err.message || "Unknown error"
        };

    }
}